 import { createSlice } from "@reduxjs/toolkit";

 const teamManagementSlice = createSlice({
    name:'teamManagement',
    initialState:{
        teamData:null
    },
    reducers:{
        setTeamData:(state,action)=>{
            state.teamData=action.payload;
        },
    },
 });

 export const {setTeamData} = teamManagementSlice.actions;

 export default teamManagementSlice.reducer;
